<div class="detail-content-block" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="30px"
	fxLayoutGap.xs="15px">
	<div class="detail-content-header" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
		<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
			<div class="descrip-block">
				<app-readability class="app-readability" [height]="(resourceDetail?.description) ? '18' : '0'">
					<content>
						<div class="fx-column fx-start-stretch">
							<ng-container *ngIf="resourceDetail?.description">
								<div class="resource-description">
									{{resourceDetail?.description}}
								</div>
							</ng-container>

							<ng-container *ngIf="resourceDetail?.skills?.length && skillMPermission">
								<div class="skill-pack fx-row-wrap fx-start-start">
									<ng-container *ngFor="let skill of resourceDetail?.skills">
										<app-chips type="progressive" background="var(--secondary-four)"
											[data]="{title: skill?.skill?.value, progress: skill?.skillLevel + '%', bufferColor: 'transparent', toolTip: true}">
										</app-chips>
									</ng-container>
								</div>
							</ng-container>
						</div>
					</content>
				</app-readability>
			</div>
		</div>
	</div>
	<div class="detail-content-body" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
		<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="20px">
			<div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="28px" class="submission-block">
				<div class="submission-content-area" fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
					<div class="event-view-block" fxLayout="column" fxLayoutAlign="start stretch">
						<div fxFlex="1 1" fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap="17px"
							fxLayoutAlign.xs="start stretch" fxLayoutGap.xs="0px">
							<div fxFlex="0 1 350px" fxFlex.xs="1 1" class="thumbnail-block" fxLayout="column"
								fxLayoutAlign="start stretch" fxLayoutGap="7px" fxLayoutGap.xs="9px">
								<div class="thumbnail cursor-pointer" (click)="embedLink()">
									<img [src]="resourceDetail?.resource?.thumbnail | safeDom : 'url'"
										(error)="gfService.setErrorImage($event, 'broken_image')" alt="">
								</div>
								<ng-container *ngIf="showCount">
									<div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutAlign.xs="center center"
										fxLayoutGap="12px" fxLayoutGap.xs="20px">
										<div class="queue cursor-pointer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px"
											(click)="requestForm('registration')">
											<span class="body-text">{{ locale.translate('registrations')}}</span>
											<span class="count-set" fxLayoutAlign="center center">{{ resourceDetail?.registrationCount
												}}</span>
										</div>
										<div class="queue cursor-pointer" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px"
											(click)="requestForm('requests')">
											<span class="body-text">{{ locale.translate('requests')}}</span>
											<span class="count-set request" fxLayoutAlign="center center">{{
												resourceDetail?.registrationRequestCount }}</span>
										</div>
									</div>
								</ng-container>
							</div>
							<div class="event-right-block" fxLayout="row" fxLayoutAlign="start stretch" fxLayoutGap="20px"
								fxLayoutGap.xs="10px">
								<div class="overview" fxFlex="0 1 414px" fxFlex.xs="1 1" fxLayout="column" fxLayoutAlign="start stretch"
									fxLayoutGap="20px">
									<div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
										<div fxFlex="0 0 auto" class="patch-big custom-patch date"
											[ngClass]="{'expired': resourceDetail?.datePassed}" fxLayoutAlign="center center" fxLayout="row">
											<ng-container *ngIf="resourceDetail?.eventTime">
												<span>{{resourceDetail?.eventTime}}</span>
												<span>|</span>
											</ng-container>
											<span>{{resourceDetail?.eventDate}}</span>
										</div>
										<!-- <ng-container *ngIf="resourceDetail?.eventTime">
												<div fxFlex="0 0 auto" class="patch-big custom-patch date" [ngClass]="{'expired': resourceDetail?.datePassed}"
													fxLayoutAlign="center center" fxLayout="row">
													<span>{{resourceDetail?.eventTime}}</span>
												</div>
											</ng-container> -->
									</div>
									<div class="venue" fxLayout="column" fxLayoutAlign="start stretch">
										<span class="sub-caption-2">{{locale.translate('venue')}}</span>
										<span class="caption">{{resourceDetail?.infoFields?.venue}}</span>
									</div>
									<div fxLayout="column" fxLayoutAlign="start stretch">
										<span class="sub-caption-2">{{locale.translate('event_link')}}:</span>
										<span class="event-link sub-caption-1 linkable"
											(click)="embedLink()">{{resourceDetail?.infoFields?.meetingLink}}
										</span>
									</div>
									<!-- <div class="status-card" fxLayout="row" fxLayoutAlign="start center">
											<div class="prime-card" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
												<p class="sub-text-1">You have registered for this.
												</p>
												<span class="hyperlink">
													Cancel</span>
											</div>
										</div> -->

									<!-- <ng-container *ngIf="showRegisterLearning && resourceDetail?.resourceAction?.registerLearning">
											<div fxFlex="1 1" class="confirmation-block" fxLayout="column" fxLayoutAlign="start stretch"
												fxLayoutGap="12px">
												<p class="sub-text-1">Did you attend this?</p>
												<div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="12px">
													<button mat-stroked-button class="action-prime-btn" (click)="registerLearning(actionEl)"
														#actionEl>{{locale.translate('register_learning')}}</button>
													<p class="hyperlink">I didn't Attend</p>
												</div>
											</div>
										</ng-container> -->
									<ng-container *ngIf="resourceDetail?.registrationStatus?.key !== 'noShow'">
										<app-registration-workflow [resourceDetail]="resourceDetail" [popupRef]="popupRef"
											(readLog)="emitReadLog()">
										</app-registration-workflow>
									</ng-container>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
		</div>
		<div class="feature-placeholder fx-column fx-start-stretch"
			[ngStyle]="{'display': detectDevice?.resolutionState$?.value?.deviceType === 'mobile' ? 'block' : 'none'}">
		</div>
	</div>
</div>
